export default __webpack_public_path__ + "f711dd07e8abc4c212f4b08d34688268.jpg";